module.exports = __webpack_public_path__ + "img/damage.e334f90f.png";